"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMedicalHistory = createMedicalHistory;
const allergiesAndSensitivities_1 = require("../../../forms/ltx/phase-i/medical-history/allergiesAndSensitivities");
const childPughClassification_1 = require("../../../forms/ltx/phase-i/medical-history/childPughClassification");
const encephalopathy_1 = require("../../../forms/ltx/phase-i/medical-history/liver-related-complications/encephalopathy");
const hepatorenalSyndrome_1 = require("../../../forms/ltx/phase-i/medical-history/liver-related-complications/hepatorenalSyndrome");
const varicealBleeding_1 = require("../../../forms/ltx/phase-i/medical-history/liver-related-complications/varicealBleeding");
const cardiovascularDiseases_1 = require("../../../forms/ltx/phase-i/medical-history/comorbidities/cardiovascularDiseases");
const endocrineDiseases_1 = require("../../../forms/ltx/phase-i/medical-history/comorbidities/endocrineDiseases");
const gastrointestinalDiseases_1 = require("../../../forms/ltx/phase-i/medical-history/comorbidities/gastrointestinalDiseases");
const respiratoryAndPulmonaryDiseases_1 = require("../../../forms/ltx/phase-i/medical-history/comorbidities/respiratoryAndPulmonaryDiseases");
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const createGreenLight_1 = require("./createGreenLight");
const createMedicalTreatment_1 = require("./createMedicalTreatment");
const messages = {
    medicalHistory: {
        id: "dashboard.medical_history",
        defaultMessage: "Anamnézis"
    },
    summaryReport: {
        id: "dashboard.summary_report",
        defaultMessage: "Anamnézis"
    },
    thoracotomiesSummary: {
        id: "dashboard.thoracotomies_summary",
        defaultMessage: "Thoracotomiák leírása"
    },
    childPughClassification: {
        id: "dashboard.child_pugh_classification",
        defaultMessage: "CHILD–PUGH osztályozás"
    },
    indicationForLiverTransplantation: {
        id: "dashboard.indication_for_liver_transplantation",
        defaultMessage: "Májtranszplantációt indokló diagnózis"
    },
    varicealBleeding: {
        id: "dashboard.variceal_bleeding",
        defaultMessage: "Varixvérzés"
    },
    encephalopathy: {
        id: "dashboard.encephalopathy",
        defaultMessage: "Encephalopathia"
    },
    encephalopathyGrade: {
        id: "dashboard.encephalopathy_grade",
        defaultMessage: "Encephalopathia fokozata"
    },
    hepatorenalSyndrome: {
        id: "dashboard.hepatorenal_syndrome",
        defaultMessage: "Hepatorenalis szindróma"
    },
    cardiovascularDiseases: {
        id: "dashboard.cardiovascular_diseases",
        defaultMessage: "Szív és érrendszeri betegségek"
    },
    endocrineDiseases: {
        id: "dashboard.endocrine_diseases",
        defaultMessage: "Endokrin betegségek"
    },
    gastrointestinalDiseases: {
        id: "dashboard.gastrointestinal_diseases",
        defaultMessage: "Gyomor- és bélrendszeri betegségek"
    },
    nephrologicalAndUrologicalDiseases: {
        id: "dashboard.nephrological_and_urological_diseases",
        defaultMessage: "Nephrológiai és urológiai betegségek"
    },
    respiratoryAndPulmonaryDiseases: {
        id: "dashboard.respiratory_and_pulmonary_diseases",
        defaultMessage: "Légúti és tüdőbetegségek"
    },
    surgicalProcedures: {
        id: "dashboard.surgical_procedures",
        defaultMessage: "Műtétek"
    },
    thrombophilia: {
        id: "dashboard.thrombophilia",
        defaultMessage: "Thrombophilia"
    },
    pregnanciesAndChildren: {
        id: "dashboard.pregnancies_and_children",
        defaultMessage: "Terhességek"
    },
    numberOfPregnancies: {
        id: "dashboard.number_of_pregnancies",
        defaultMessage: "Terhességek száma"
    },
    numberOfChildren: {
        id: "dashboard.number_of_children",
        defaultMessage: "Gyerekek száma"
    },
    allergiesAndSensitivities: {
        id: "dashboard.allergies_and_sensitivities",
        defaultMessage: "Allergiák és érzékenységek"
    },
    allergyType: {
        id: "dashboard.allergy_type",
        defaultMessage: "Allergia típusa"
    },
    allergyName: {
        id: "dashboard.allergy_name",
        defaultMessage: "Allergia neve"
    },
    allergyComment: {
        id: "dashboard.allergy_comment",
        defaultMessage: "Megjegyzés"
    },
    surgicalProcedureName: {
        id: "dashboard.surgical_procedure_name",
        defaultMessage: "Műtét neve"
    },
    surgicalProcedureDate: {
        id: "dashboard.surgical_procedure_date",
        defaultMessage: "Műtét dátuma"
    },
    date: {
        id: "dashboard.comorbidity_date",
        defaultMessage: "Dátum"
    },
    value: {
        id: "dashboard.comorbidity_value",
        defaultMessage: "Betegség"
    }
};
function createMedicalHistory(intl, options) {
    const greenLight = (0, createGreenLight_1.createGreenLight)(intl, options);
    const childPughClassification = createChildPughClassification(intl, options);
    const indicationForLiverTransplantation = createIndicationForLiverTransplantation(intl, options);
    const varicealBleeding = createVaricealBleeding(intl, options);
    const encephalopathy = createEncephalopathy(intl, options);
    const hepatorenalSyndrome = createHepatorenalSyndrome(intl, options);
    const comorbidityTables = createComorbidityTables(intl, options);
    const pregnanciesAndChildren = createPregnanciesAndChildren(intl, options);
    const allergiesAndSensitivities = createAllergiesAndSensitivities(intl, options);
    const surgicalProcedures = createSurgicalProcedures(intl, options);
    const summaryReport = createSummaryReport(intl, options);
    const medicalTreatment = (0, createMedicalTreatment_1.createMedicalTreatment)(intl, options);
    const content = (0, shared_1.createSectionContent)([
        greenLight,
        childPughClassification,
        indicationForLiverTransplantation,
        varicealBleeding,
        encephalopathy,
        hepatorenalSyndrome,
        ...comorbidityTables,
        surgicalProcedures,
        pregnanciesAndChildren,
        allergiesAndSensitivities,
        summaryReport,
        medicalTreatment
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.medicalHistory, content });
}
function createSummaryReport(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.summaryReport,
        query: queries_1.queries.summaryReport
    });
}
function createChildPughClassification(intl, { events }) {
    return (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        variant: "short",
        label: messages.childPughClassification,
        query: queries_1.queries.childPughClassification,
        messages: childPughClassification_1.childClassificationMessages
    });
}
function createIndicationForLiverTransplantation(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.indicationForLiverTransplantation,
        query: queries_1.queries.indicationForLiverTransplantation
    });
}
function createVaricealBleeding(intl, { events }) {
    return (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        variant: "short",
        label: messages.varicealBleeding,
        query: queries_1.queries.varicealBleeding,
        messages: varicealBleeding_1.hasOccurredMessages
    });
}
function createEncephalopathy(intl, { events }) {
    return (0, shared_1.createMixedList)(intl, {
        events,
        label: messages.encephalopathy,
        values: [
            {
                label: messages.encephalopathy,
                query: queries_1.queries.encephalopathy,
                type: "formatted-message",
                messages: encephalopathy_1.hasOccurredMessages
            },
            {
                label: messages.encephalopathyGrade,
                query: queries_1.queries.encephalopathyGrade,
                type: "formatted-message",
                messages: encephalopathy_1.encephalopathyGradeMessages
            }
        ]
    });
}
function createHepatorenalSyndrome(intl, { events }) {
    return (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        variant: "short",
        label: messages.hepatorenalSyndrome,
        query: queries_1.queries.hepatorenalSyndrome,
        messages: hepatorenalSyndrome_1.hasOccurredMessages
    });
}
const comorbidities = [
    {
        label: messages.cardiovascularDiseases,
        query: queries_1.queries.cardiovascularDiseases,
        messages: cardiovascularDiseases_1.diseasesMessages
    },
    {
        label: messages.endocrineDiseases,
        query: queries_1.queries.endocrineDiseases,
        messages: endocrineDiseases_1.diseasesMessages
    },
    {
        label: messages.gastrointestinalDiseases,
        query: queries_1.queries.gastrointestinalDiseases,
        messages: gastrointestinalDiseases_1.diseasesMessages
    },
    {
        label: messages.nephrologicalAndUrologicalDiseases,
        query: queries_1.queries.nephrologicalAndUrologicalDiseases
    },
    {
        label: messages.respiratoryAndPulmonaryDiseases,
        query: queries_1.queries.respiratoryAndPulmonaryDiseases,
        messages: respiratoryAndPulmonaryDiseases_1.diseasesMessages
    },
    {
        label: messages.thrombophilia,
        query: queries_1.queries.thrombophilia
    }
];
function createComorbidityTables(intl, { events }) {
    const { formatMessage, formatMessageMap, formatDate } = intl;
    const columns = [
        formatMessage(messages.date),
        formatMessage(messages.value)
    ];
    const tables = [];
    for (const { label, query, messages: valueMessages } of comorbidities) {
        const relevantEvents = (0, utils_1.findEventsByQuery)(events, query);
        if (relevantEvents.length === 0) {
            continue;
        }
        const sortedEvents = relevantEvents.sort(shared_1.compareByTimestamp);
        const attachments = (0, utils_1.mapEventsToAttachments)(sortedEvents);
        const rows = sortedEvents.map(event => {
            const formattedDate = formatDate(event.timestamp, {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            });
            const resultValue = valueMessages !== undefined
                ? formatMessageMap(valueMessages, event.value)
                : event.value;
            return [formattedDate, resultValue];
        });
        tables.push({
            type: "table",
            label: formatMessage(label),
            attachments,
            columns,
            rows
        });
    }
    return tables;
}
function createPregnanciesAndChildren({ formatMessage }, { events }) {
    const event = (0, utils_1.findLastEventByQuery)(events, queries_1.queries.pregnanciesAndChildren);
    if (event === undefined) {
        return undefined;
    }
    const numberOfPregnancies = {
        type: "list-item",
        label: formatMessage(messages.numberOfPregnancies),
        value: `${event.value.numberOfPregnancies}`
    };
    const numberOfChildren = {
        type: "list-item",
        label: formatMessage(messages.numberOfChildren),
        value: `${event.value.numberOfChildren}`
    };
    const items = [numberOfPregnancies, numberOfChildren];
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, utils_1.mapEventsToAttachments)(event),
        origin,
        label: formatMessage(messages.pregnanciesAndChildren),
        items
    };
}
function createAllergiesAndSensitivities({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, utils_1.findLastEventByQuery)(events, queries_1.queries.allergiesAndSensitivities);
    if (event === undefined) {
        return undefined;
    }
    const { allergy } = event.value;
    if (allergy === undefined || allergy.length === 0) {
        return undefined;
    }
    const columns = [
        formatMessage(messages.allergyType),
        formatMessage(messages.allergyName),
        formatMessage(messages.allergyComment)
    ];
    const rows = allergy.map(({ allergyType, allergyName, comment }) => [
        formatMessageMap(allergiesAndSensitivities_1.allergyTypeMessages, allergyType),
        allergyName,
        comment ?? ""
    ]);
    const { timestamp, sid, origin } = event;
    return {
        type: "table",
        label: formatMessage(messages.allergiesAndSensitivities),
        attachments: (0, utils_1.mapEventsToAttachments)(event),
        columns,
        rows,
        timestamp,
        sid,
        origin
    };
}
function createSurgicalProcedures({ formatMessage }, { events }) {
    const event = (0, utils_1.findLastEventByQuery)(events, queries_1.queries.surgicalProcedures);
    if (event === undefined) {
        return undefined;
    }
    const { surgicalProcedureType } = event.value;
    if (surgicalProcedureType === undefined ||
        surgicalProcedureType.length === 0) {
        return undefined;
    }
    const columns = [
        formatMessage(messages.surgicalProcedureName),
        formatMessage(messages.surgicalProcedureDate)
    ];
    const rows = surgicalProcedureType.map(({ surgicalProcedureName, dateOfSurgicalProcedure }) => [
        surgicalProcedureName,
        dateOfSurgicalProcedure
    ]);
    const { timestamp, sid, origin } = event;
    return {
        type: "table",
        label: formatMessage(messages.surgicalProcedures),
        attachments: (0, utils_1.mapEventsToAttachments)(event),
        columns,
        rows,
        timestamp,
        sid,
        origin
    };
}
